import React from 'react';

type BtnVariant = 'accent' | 'ghost' | 'outline' | 'danger' | 'success';
type BtnSize = 'xs' | 'sm' | 'md' | 'lg';

interface ButtonProps {
  variant?: BtnVariant;
  size?: BtnSize;
  block?: boolean;
  icon?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
  type?: 'button' | 'submit' | 'reset';
  style?: React.CSSProperties;
  className?: string;
}

export default function Button({
  variant = 'ghost', size = 'md', block, icon, disabled, onClick, children, type = 'button', style, className = '',
}: ButtonProps) {
  const cls = [
    't-btn', variant,
    size !== 'md' ? size : '',
    block ? 'block' : '',
    icon ? 'icon' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button className={cls} onClick={onClick} disabled={disabled} type={type} style={style}>
      {children}
    </button>
  );
}
